import { Component, Input } from '@angular/core';

/**
 * Generated class for the EffectStatsIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'effect-stats-icon',
  templateUrl: 'effect-stats-icon.html'
})
export class EffectStatsIconComponent {

  @Input()
  effectStats: [number, number, number];

  thresholdSome = 6;
  thresholdMany = 21;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/effect-stats-icon/effect-stats-icon.ts